import i18n from 'locales/i18n';

import { PlatformCode } from 'src/type/common';

import { NBAccountRes, NBReportRes } from '@apis/orval/model';

import { setTotalVisitorRange } from '@utils/filterList';

import round from '@utils/round';

import { SimilarGroupNbProps } from './SimilarGroupNb';

export class SimilarGroupNbAdapter {
	value: NBReportRes;

	constructor(obj: NBReportRes) {
		this.value = obj;
	}

	get similarGroup() {
		return this.value?.account_recommendations?.similar_group_accounts ?? [];
	}

	columns = ['일 방문자', '누적 방문자'] as [string, string];

	getCategoriesFromAccount(item: NBAccountRes): string[] {
		// const category1 = instagramCategories.get(item?.category_1)?.() ?? '';
		// const category2 = instagramCategories.get(item?.category_2)?.() ?? '';
		const category1 = item?.category_1 ?? '';
		const category2 = item?.category_2 ?? '';

		return [category1, category2].filter((v) => v) as string[];
	}

	getTablePropsItem(
		accountData: NBAccountRes,
	): SimilarGroupNbProps<['일 방문자', '누적 방문자']>['data'][number] {
		return {
			pk: accountData?.profile?.platform_pk ?? undefined,
			userName: accountData?.profile?.username ?? undefined,
			fullName: accountData?.profile?.full_name ?? undefined,
			profileImg: accountData?.profile?.profile_img_link ?? undefined,
			platformCode: (accountData?.profile?.platform_code as PlatformCode) ?? undefined,
			categories: this.getCategoriesFromAccount(accountData),
			[this.columns[0]]: i18n?.t('unit.number-of-person', {
				number: accountData?.profile?.avg_daily_visitor
					? round(accountData?.profile?.avg_daily_visitor, 'down')
					: '-',
			}),
			[this.columns[1]]: i18n?.t('unit.number-of-person', {
				number: accountData?.profile?.total_visitor
					? round(accountData?.profile?.total_visitor, 'down')
					: '-',
			}),
		};
	}

	get userName() {
		return this.value.account?.profile?.username ?? '-';
	}

	get category() {
		const category1 = this.value.account?.category_1 ?? '';
		const category2 = this.value.account?.category_2 ?? '';
		return ([category1, category2].filter((v) => v) as string[]).join(', ') ?? '-';
	}

	get followers() {
		return this.value.account?.profile?.total_visitor
			? setTotalVisitorRange(this.value.account?.profile?.total_visitor)
			: '-';
	}

	adapt(): {
		props: SimilarGroupNbProps<['팔로워', '유효 팔로워']>;
		desc: {
			userName?: string;
			category?: string;
			followers?: string;
		};
	} {
		return {
			props: {
				header: this.columns as ['팔로워', '유효 팔로워'],
				data: this.similarGroup.map((accountData) => this.getTablePropsItem(accountData)),
			},
			desc: {
				userName: this.userName,
				category: this.category,
				followers: this.followers,
			},
		};
	}
}
